import { Guid } from 'guid-typescript';

export class Extensions {

    public static isStringNullOrEmpty(str: string) {
        return !str || str == null || str === '';
    }

    public static isArrayNullOrEmpty<T>(tab: T[]) {
        return !tab || tab == null || tab.length === 0;
    }

    public static isNull(obj: any) {
        return !obj || obj == null;
    }

    public static isEmpty(obj: any) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    public static isGuidNullOrEmpty(str: string) {
        return !str || str == null || str === '' || str === Guid.EMPTY.toString();
    }
}
